import { HStack } from "../../../../components/composition/stack.layout";
import { openApplicantSignInModal } from "../../../../components/molecules/modals/ats/public-sign-in-modal.tsx/verify-email-sign-in-modal";
import useGetApplicantLoginInfo from "../../../../components/utils/useGetApplicantLoginInfo";
import useRouterVariable from "../../../../components/utils/useRouterVariable";
import {
  useFetchOrgDisplayName,
  useFetchOrgLogoLinkv2,
} from "../../../api-docs";
import { EmailSignInButton } from "../../components/email-sign-in-button";
import { JobFilterUI } from "../../job-list/components/filters/ui";
import { HeaderLogo } from "../../components/header-logo";
import { Header } from "../../components/header/header";

export const CandidateSelfApplyHeader = () => {
  const { applicantLoginInfo } = useGetApplicantLoginInfo();
  const orgName = useRouterVariable("org", (o) => o as string);
  const orgLogo = useFetchOrgLogoLinkv2(
    { orgFriendlyName: orgName },
    {
      query: {
        enabled: orgName != null,
      },
    },
  );
  const orgDisplayName = useFetchOrgDisplayName(
    { orgFriendlyName: orgName },
    {
      query: {
        enabled: orgName != null,
      },
    },
  );

  const title = orgDisplayName.data
    ? `Job Openings at ${orgDisplayName.data}`
    : "";

  return (
    <Header
      leading={
        <HeaderLogo
          logo={orgLogo.data}
          sidebar={
            <div className="flex h-full w-full flex-col gap-y-4 bg-white px-4 py-4 shadow">
              <JobFilterUI showCloseButtonForMobile />
            </div>
          }
        />
      }
      content={
        <h1 className="flex items-center justify-center text-base font-medium leading-normal">
          {title}
        </h1>
      }
      trailing={
        <HStack className={"w-full items-center justify-end"}>
          <EmailSignInButton
            isLoggedIn={
              applicantLoginInfo.success
                ? {
                    email: applicantLoginInfo?.email,
                  }
                : undefined
            }
            onClick={openApplicantSignInModal}
          />
        </HStack>
      }
    />
  );
};
